import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "shield",
  "use": "shield-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"shield\">\n<path d=\"M12,23c-0.2,0-0.3,0-0.4-0.1C11.2,22.7,3,18.5,3,12V5c0-0.4,0.3-0.8,0.6-0.9l8-3c0.2-0.1,0.5-0.1,0.7,0l8,3\n\tC20.7,4.2,21,4.6,21,5v7c0,6.5-8.2,10.7-8.6,10.9C12.3,23,12.2,23,12,23z M5,5.7V12c0,4.5,5.4,7.9,7,8.9c1.6-0.9,7-4.3,7-8.9V5.7\n\tl-7-2.6L5,5.7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol